import { ORG_ONE_PRICES, ORG_FIVE_PRICES, ORG_SEVEN_PRICES, ORG_FOURTEEN_PRICES } from '../components/Signup/Prices';

export default function getPlanPrice(planType, billingFrequency, currency, orgId) {
  if (planType && billingFrequency && currency && orgId) {
    let usePrices;
    switch (orgId) {
      case 1:  // TCM
        usePrices = ORG_ONE_PRICES;
        break;
      case 5:  // AYSO Coaching
        usePrices = ORG_FIVE_PRICES;
        break;
      case 7: // Rangers FC
        usePrices = ORG_SEVEN_PRICES;
        break;
      case 14: // Challenger
        usePrices = ORG_FOURTEEN_PRICES;
        break;
      default:
        usePrices = null;
    }
    return usePrices[planType][billingFrequency][currency];
  }
  return null;
}



// WEBPACK FOOTER //
// ./library/app/utils/getPlanPrice.js